import { Box, Typography, Tooltip } from '@mui/material'
import { CheckCircle, Schedule, Warning } from '@mui/icons-material'
import { status as statusTokens } from '../../theme/tokens'
import { formatNumber, formatPercent } from '../../utils/format'

const STATUS_CONFIG = {
  healthy: {
    color: statusTokens.ok.color,
    bg: statusTokens.ok.bg,
    icon: CheckCircle,
    label: 'Healthy',
  },
  caution: {
    color: statusTokens.warning.color,
    bg: statusTokens.warning.bg,
    icon: Schedule,
    label: 'Caution',
  },
  overloaded: {
    color: statusTokens.critical.color,
    bg: statusTokens.critical.bg,
    icon: Warning,
    label: 'Overloaded',
  },
}

function getStatus(utilization) {
  if (utilization > 100) return 'overloaded'
  if (utilization >= 85) return 'caution'
  return 'healthy'
}

export default function CapacityCell({
  scheduledHours,
  netAvailableHours,
  utilizationPercent,
  onClick,
  isTotal = false,
}) {
  const derivedStatus = getStatus(utilizationPercent)
  const config = STATUS_CONFIG[derivedStatus]
  const Icon = config.icon
  const barWidth = Math.min(utilizationPercent, 120)

  return (
    <Tooltip
      title={`${config.label}: ${formatNumber(scheduledHours)} / ${formatNumber(netAvailableHours)} hrs (${formatPercent(utilizationPercent)})`}
    >
      <Box
        onClick={onClick}
        sx={{
          p: 1,
          cursor: onClick ? 'pointer' : 'default',
          borderRadius: 1,
          backgroundColor: config.bg,
          border: '1px solid',
          borderColor: `${config.color}33`,
          transition: 'box-shadow 0.15s',
          minWidth: 100,
          '&:hover': onClick
            ? { boxShadow: `0 0 0 2px ${config.color}44` }
            : undefined,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography
            variant="caption"
            sx={{ fontWeight: isTotal ? 700 : 500, color: config.color }}
          >
            {formatNumber(scheduledHours)} / {formatNumber(netAvailableHours)}
          </Typography>
          <Icon sx={{ fontSize: 14, color: config.color }} />
        </Box>

        <Box sx={{
          height: 6,
          borderRadius: 3,
          backgroundColor: `${config.color}22`,
          overflow: 'hidden',
          mb: 0.5,
        }}>
          <Box sx={{
            height: '100%',
            width: `${Math.min(barWidth, 100)}%`,
            backgroundColor: config.color,
            borderRadius: 3,
            transition: 'width 0.3s ease',
          }} />
        </Box>

        <Typography
          variant="caption"
          sx={{ fontWeight: 600, color: config.color, fontSize: '0.65rem' }}
        >
          {formatPercent(utilizationPercent)}
        </Typography>
      </Box>
    </Tooltip>
  )
}
